module.exports = __webpack_public_path__ + "static/media/User_Icon.f8485d7e.svg";